import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public

/**
 * Returns the system's OnlineUntil value if system is online, returns null if system is offline.
 * @returns {Promise<Date>?}
*/
export async function onlineUntil() {
	const now = Date.now();
	const onlineUntilRaw = await Auth.GET(`/system/onlineUntil`);
	if (onlineUntilRaw) {
		const onlineUntilDate = new Date(onlineUntilRaw);
		if (onlineUntilDate > now) {
			return onlineUntil;
		}
	}

	return null;
}

/**
 * Returns if the system is online or not.
 * @returns {Promise<boolean>}
*/
export async function isOnline() {
	const onlineUntilDate = await onlineUntil();
	return !!onlineUntilDate;
}

/**
 * Updates the Notary's Online Until "heartbeat" status
*/
export async function notaryOnline() {
	await Auth.POST(`/system/notaryOnline`, undefined, undefined, true);
}